import { c as _c } from "react/compiler-runtime";
import NumberInput from "@components/hookform/NumberInput";
import { logger } from "@justhome/common";
import { MaximumBudget, usePostMaximumBudget } from "@justhome/api-core";
import { AppModal, Button, InlineNotification, Title } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import { useState } from "react";
import { useForm } from "react-hook-form";
const MaximumBudgetEditModal = () => {
  const $ = _c(91);
  const [isOpen, setIsOpen] = useState(false);
  const {
    t
  } = useApplicationTranslation();
  const {
    state,
    dispatch
  } = useApplicationContext();
  const {
    partner
  } = usePartnerContext();
  let t0;
  if ($[0] !== dispatch) {
    t0 = {
      onSuccess: maximumBudget => {
        dispatch({
          type: "SET_MAXIMUM_BUDGET",
          maximumBudget
        });
      },
      onError: _temp
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutateAsync: postMaximumBudget,
    isLoading,
    isError
  } = usePostMaximumBudget(t0);
  let t1;
  if ($[2] !== partner?.id || $[3] !== postMaximumBudget || $[4] !== state.lead?.id) {
    t1 = async values => {
      const {
        id: _,
        ...body
      } = values;
      await postMaximumBudget({
        body: {
          ...body,
          leadId: state.lead?.id,
          partnerId: partner?.id
        }
      });
      setIsOpen(false);
    };
    $[2] = partner?.id;
    $[3] = postMaximumBudget;
    $[4] = state.lead?.id;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onSubmit = t1;
  let t2;
  if ($[6] !== state.maximumBudget) {
    t2 = {
      mode: "onBlur",
      defaultValues: {
        ...state.maximumBudget
      }
    };
    $[6] = state.maximumBudget;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    control,
    handleSubmit
  } = useForm(t2);
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(true);
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("edit_details_label");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <Button size="xs" variant="ghost" iconEnd="Edit" onClick={t3}>{t4}</Button>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("edit_details_label");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <AppModal.Title closable={true}><Title as="h3" className="text-h2">{t6}</Title></AppModal.Title>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== handleSubmit || $[18] !== onSubmit) {
    t8 = handleSubmit(onSubmit);
    $[17] = handleSubmit;
    $[18] = onSubmit;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("down_payment_label");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("down_payment_placeholder");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("error_down_payment");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = {
      required: {
        value: true,
        message: t11
      },
      min: 0
    };
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("down_payment_info");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== control || $[31] !== isLoading || $[32] !== t10 || $[33] !== t12 || $[34] !== t13 || $[35] !== t9) {
    t14 = <NumberInput className="col-span-2" disabled={isLoading} label={t9} placeholder={t10} name="equity" control={control} size="md" suffix={"\u20AC"} rules={t12} info={t13} />;
    $[30] = control;
    $[31] = isLoading;
    $[32] = t10;
    $[33] = t12;
    $[34] = t13;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t) {
    t15 = t("monthly_net_income_label");
    $[37] = t;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t) {
    t16 = t("monthly_net_income_placeholder");
    $[39] = t;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t) {
    t17 = t("error_monthly_net_income");
    $[41] = t;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t17) {
    t18 = {
      value: true,
      message: t17
    };
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t) {
    t19 = t("error_monthly_net_income");
    $[45] = t;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t19) {
    t20 = {
      value: 1800,
      message: t19
    };
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t18 || $[50] !== t20) {
    t21 = {
      required: t18,
      min: t20
    };
    $[49] = t18;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t) {
    t22 = t("monthly_net_income_info");
    $[52] = t;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== control || $[55] !== isLoading || $[56] !== t15 || $[57] !== t16 || $[58] !== t21 || $[59] !== t22) {
    t23 = <NumberInput className="col-span-2" disabled={isLoading} label={t15} placeholder={t16} name="monthlyNetIncome" control={control} size="md" suffix={"\u20AC"} rules={t21} info={t22} />;
    $[54] = control;
    $[55] = isLoading;
    $[56] = t15;
    $[57] = t16;
    $[58] = t21;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== isError || $[62] !== t) {
    t24 = isError && <InlineNotification className="col-span-2 mt-2s mb-s" type="error">{t("generic_error")}</InlineNotification>;
    $[61] = isError;
    $[62] = t;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = () => setIsOpen(false);
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== t) {
    t26 = t("cancel_button");
    $[65] = t;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== isLoading || $[68] !== t26) {
    t27 = <Button variant="outline_primary" type="button" className="!w-auto" size="md" disabled={isLoading} onClick={t25}>{t26}</Button>;
    $[67] = isLoading;
    $[68] = t26;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== t) {
    t28 = t("save_changes_button");
    $[70] = t;
    $[71] = t28;
  } else {
    t28 = $[71];
  }
  let t29;
  if ($[72] !== isLoading || $[73] !== t28) {
    t29 = <Button variant="primary" type="submit" className="!w-auto" size="md" isLoading={isLoading}>{t28}</Button>;
    $[72] = isLoading;
    $[73] = t28;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== t27 || $[76] !== t29) {
    t30 = <div className="col-span-2 flex justify-start gap-2s text-center">{t27}{t29}</div>;
    $[75] = t27;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== t14 || $[79] !== t23 || $[80] !== t24 || $[81] !== t30 || $[82] !== t8) {
    t31 = <AppModal.Content><form onSubmit={t8} className="grid grid-cols-2 gap items-end">{t14}{t23}{t24}{t30}</form></AppModal.Content>;
    $[78] = t14;
    $[79] = t23;
    $[80] = t24;
    $[81] = t30;
    $[82] = t8;
    $[83] = t31;
  } else {
    t31 = $[83];
  }
  let t32;
  if ($[84] !== isOpen || $[85] !== t31 || $[86] !== t7) {
    t32 = <AppModal className="w-full max-w-lg" isOpen={isOpen} onOpenChange={setIsOpen}>{t7}{t31}</AppModal>;
    $[84] = isOpen;
    $[85] = t31;
    $[86] = t7;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t32 || $[89] !== t5) {
    t33 = <div className="border-t border-neutral-50 px-3xs flex items-center justify-end w-full py-3xs">{t5}{t32}</div>;
    $[88] = t32;
    $[89] = t5;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  return t33;
};
export default MaximumBudgetEditModal;
function _temp(err) {
  logger.error("Failed to post maximum budget", err);
}